module.exports = __webpack_public_path__ + "static/media/nothing.1c95a1a4.png";